import './Tools.css';
import { Link } from 'react-router-dom';
import payLessInterest from './images/pay-less-interest.svg';
import payDebtFaster from './images/pay-debt-faster.svg';
import boostCreditScore from './images/boost-credit-score.svg'
import ddr from './images/ddr.svg'
import { Fragment } from 'react';

function Tools() {
  function getImage() {
    return (
      <Fragment>

      </Fragment>
    )
  }
  return (
    <section className='tools'>
      
      <p className='tools-subtitle'>
      Sound familiar? If so, then Sera can help!
      </p>
      
      <div className='tools-container'>
        <div>
        <div className='tool'>
          <div className='section-title'>
            <img src={boostCreditScore} alt="BoostCreditScore" />
            <div className='title'>Boost your credit</div>
          </div>
          <p className='description'>Link your checking account and we'll report your regular payments to the credit bureaus, building your score.</p>
        </div>
        <div className='tool'>
          <div className='section-title'>
            <img src={payLessInterest} alt="PayLessInterest" />
            <p className='title'>Pay less interest</p>
          </div>
          <p className='description'>Leverage your checking account to reduce your credit-card daily balance and thus shorten the time it takes to pay off your debt.</p>
        </div>
        <div className='tool'>
          <div className='section-title'>
            <img src={payDebtFaster} alt="PayDebtFaster" />
            <p className='title'>Control your spending</p>
          </div>
          <p className='description'>Know your mandatory and discretionary spending patterns to build good financial habits.</p>
        </div>
        </div>
        <Link to='/how-it-works'><button className='main'>See how it works</button></Link>
      </div>
      {/*
      <div className='tools-blurb big'>
        <div className='what-is-sera'>
          <p className='title neutral-white'>What is Sera?</p>
          <p className='description neutral-white'>
          Sera's mission is to help you achieve financial freedom as quickly as possible by bundling your checking account and credit card along with your regular monthly bill payments into a simple, automated and powerful solution to build your credit score and eliminate your debt.
          </p>
          <Link to='/debt-payoff-calculator'>
            <button  className='main'>
              Calculate my savings
            </button>
          </Link>
        </div>
        <img alt="" />
      </div>

      <div className='tools-blurb small'>
        <img alt="" />
        <div className='what-is-sera'>
          <p className='title neutral-white'>What is Sera?</p>
          <p className='description neutral-white'>
          Sera's mission is to help you achieve financial freedom as quickly as possible by bundling your checking account and credit card along with your regular monthly bill payments into a simple, automated and powerful solution to build your credit score and eliminate your debt.
          </p>
          <Link to='/debt-payoff-calculator'>
            <button  className='main'>
              Calculate my savings
            </button>
          </Link>
        </div>
      </div>
      */}
      <div className='what-is-sera'>
        <p className='title neutral-white'>What is Sera?</p>
        <img src={ddr} />
        <div>
          <p className='description neutral-white'>
          Sera's mission is to help you achieve financial freedom as quickly as possible by bundling your checking account and credit card along with your regular monthly bill payments into a simple, automated and powerful solution to build your credit score and eliminate your debt.
          </p>
          <Link to='/debt-payoff-calculator'>
            <button  className='main'>
              Calculate my savings
            </button>
          </Link>
        </div>
      </div>

    </section>
  );
}

export default Tools;